import { MessageCircle } from "lucide-react";
import { whatsappUrl } from "@/lib/clinic";

export default function FloatingWhatsapp() {
  return (
    <a
      href={whatsappUrl()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Agendá tu turno por WhatsApp"
      data-testid="floating-whatsapp"
      className="fixed bottom-6 right-6 z-[60] group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 blur-lg group-hover:opacity-80 transition-opacity" />
      <span className="relative flex items-center gap-3 rounded-full bg-[#25D366] hover:bg-[#1fb857] text-white pl-4 pr-5 py-4 shadow-[0_12px_28px_-8px_rgba(37,211,102,0.55)] transition-all duration-300 hover:-translate-y-0.5">
        <MessageCircle className="w-6 h-6" strokeWidth={2.2} />
        <span className="hidden sm:inline text-sm font-semibold">Agendá tu turno</span>
      </span>
    </a>
  );
}
